import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { IMAGES } from '../layout/theme';
import TestimonialCard from '../element/TestimonialCard';
import feedbackService, { Feedback } from '../services/feedbackService';

// Fallback data in case API fails
const FallbackTestimonialData = [
    {
        image: IMAGES.TestImg1,
        name: 'Irene & Richard',
        location: 'Babelina Legal - Spain',
        testimonial: 'Ana, sin duda alguna, es la mejor limpiadora que hemos tenido jamás. Es puntual, rápida, profesional y eficaz. Hace limpiezas perfectas que nos gustan mucho. A su vez es también muy agradable en el trato y de gran confianza. Nos consideramos muy afortunados por poder contar con los servicios de Ana y la recomendamos.',
        rating: 5
    },
    {
        image: IMAGES.TestImg2,
        name: 'Mandy',
        location: 'Spain',
        testimonial: 'Muy profesional, servicio super rápido! Muy recomendable 💯',
        rating: 5
    },
    {
        image: IMAGES.TestImg3,
        name: 'Customer',
        location: 'France',
        testimonial: 'Je les recommande... très professionnels, attentionnés, sympathiques et 100% engagés dans le travail qu\'ils font... on voit qu\'ils le font avec plaisir... merci',
        rating: 5
    },
    {
        image: IMAGES.TestImg1,
        name: 'Francisco',
        location: 'UK',
        testimonial: 'Absolutely amazing service! They take care of cleaning, upholstery, and even key holding, and they do it all with such professionalism. Always reliable, trustworthy, and friendly. It\'s such a relief knowing I can count on them. Highly recommend!',
        rating: 5
    },
    {
        image: IMAGES.TestImg2,
        name: 'Patricia',
        location: 'UK',
        testimonial: 'Very professional and trustworthy. A well-done and detailed job, and I couldn\'t recommend it more',
        rating: 5
    },
    {
        image: IMAGES.TestImg3,
        name: 'Customer',
        location: 'Spain',
        testimonial: 'Un equipo fantástico, responsable y súper eficiente con un servicio impecable. Lo recomiendo.',
        rating: 5
    },
    {
        image: IMAGES.TestImg1,
        name: 'Pedro',
        location: 'UK',
        testimonial: 'I had an amazing experience with their cleaning service! Both the house cleaning and the upholstery cleaning were done to perfection. Everything looks spotless, fresh, and like new. The team was professional, thorough, and went above and beyond my expectations. I highly recommend their services 100%!',
        rating: 5
    }
]

const settings = {
    dots: true,
    infinite: true,    
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
            }
        },
  	    {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
  	    }
    ]
};

const TestimonialBlog = () => {
    const [testimonials, setTestimonials] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchFeedbacks();
    }, []);

    const fetchFeedbacks = async () => {
        try {
            setLoading(true);
            const feedbacks = await feedbackService.getAll();

            // Map feedbacks to testimonial format
            const mappedTestimonials = feedbacks.map((feedback: Feedback, index: number) => ({
                image: IMAGES[`TestImg${(index % 3) + 1}` as keyof typeof IMAGES] || IMAGES.TestImg1,
                name: feedback.name,
                location: '', // Feedbacks don't have location, could be added to database if needed
                testimonial: feedback.message,
                rating: feedback.rating,
                avatarColor: feedback.avatar_color
            }));

            setTestimonials(mappedTestimonials.length > 0 ? mappedTestimonials : FallbackTestimonialData);
        } catch (error) {
            console.error('Error fetching feedbacks:', error);
            // Use fallback data if API fails
            setTestimonials(FallbackTestimonialData);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="main-testimonial-slider">
                <div style={{ textAlign: 'center', padding: '50px 0' }}>
                    <p>Loading testimonials...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="main-testimonial-slider">

                <Slider
                    className="testimonial-slider"
                    {...settings}
                >
                    {testimonials.map((item, ind)=>(
                        <TestimonialCard
                            image={item.image}
                            name={item.name}
                            location={item.location}
                            testimonial={item.testimonial}
                            rating={item.rating}
                            avatarColor={item.avatarColor}
                            key={ind}
                        />
                    ))}
                </Slider>

        </div>

    );
};

export default TestimonialBlog;